import Hero from './components/Hero';
import DemoReel from './components/DemoReel';
import Press from './components/Press';
import Bio from './components/Bio';
import Gallery from './components/Gallery';
import Contact from './components/Contact';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <DemoReel />
      <Press />
      <Bio />
      <Gallery />
      <Contact />
    </main>
  );
};

export default HomePage;